export default "__VITE_ASSET__Bx3ipiX9__"